import React from 'react';
import { Route } from 'react-router';
import getWidget from '../member-pages-common/containers/widget';
import ProfileBlogPosts from './containers/profile-blog-posts';

export default () => <Route path="*" component={getWidget(ProfileBlogPosts)} />;
